import { render, staticRenderFns } from "./ContactNoteItem.vue?vue&type=template&id=2bda3bdf"
import script from "./ContactNoteItem.vue?vue&type=script&lang=js"
export * from "./ContactNoteItem.vue?vue&type=script&lang=js"
import style0 from "./ContactNoteItem.vue?vue&type=style&index=0&id=2bda3bdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports